import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import React, { Suspense, useEffect, useState } from 'react';

import { queryClient } from './queryClient';

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({
      default: d.ReactQueryDevtools,
    }),
  ),
);

export const QueryClientProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  // Start disabled so the server render and the first client render match.
  // Enabling on mount (client-only) keeps the lazy, client-only devtools out of
  // hydration — otherwise SSR emits the Suspense fallback (null) while the
  // client renders the devtools panel, crashing hydration in dev.
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    if (import.meta.env.DEV) {
      setShowDevtools(true);
    }
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  return (
    <TanstackQueryClientProvider client={queryClient}>
      {children}
      {showDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevtoolsProduction />
        </Suspense>
      )}
    </TanstackQueryClientProvider>
  );
};
